import { render, staticRenderFns } from "./poetry.vue?vue&type=template&id=de04bd6c&scoped=true&"
import script from "./poetry.vue?vue&type=script&lang=js&"
export * from "./poetry.vue?vue&type=script&lang=js&"
import style0 from "./poetry.vue?vue&type=style&index=0&id=de04bd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de04bd6c",
  null
  
)

export default component.exports